import React from 'react';
import { Profile, User } from 'store/accounts/type';
import _ from 'lodash';
import { default_profile } from 'constants/image';
import { useDispatch } from 'react-redux';
import { communityActions } from 'store/community';
import { useRouter } from 'next/router';

interface IProps {
  closeModal: () => void;
  user: User;
  profile?: Profile;
}

const ModalMyProfile: React.FC<IProps> = ({
  closeModal,
  user,
  profile,
}: IProps) => {
  const { keywords } = profile;
  const profile_image =
    profile.profile_picture === null
      ? default_profile
      : profile.profile_picture;
  const dispatch = useDispatch();
  const router = useRouter();

  const convertHashTag = keyword => {
    return `#${keyword} `;
  };

  const hasSNS =
    !_.isEmpty(profile.facebook_username) ||
    !_.isEmpty(profile.instagram_username) ||
    !_.isEmpty(profile.website);

  const snsList = hasSNS
    ? [
        {
          s_name: 'facebook',
          c_name: 's-facebook',
          name: profile.facebook_username,
          href: `https://www.facebook.com/${profile.facebook_username}`,
        },
        {
          s_name: 'instagram',
          c_name: 's-insta',
          name: profile.instagram_username,
          href: `https://www.instagram.com/${profile.instagram_username}`,
        },
        {
          s_name: 'website',
          c_name: 's-etc',
          name: profile.website,
          href: profile.website,
        },
      ]
    : [];

  const clickOtherFeeds = () => {
    dispatch(communityActions.setCommunitySelectUser(user));
    router.push(`/community/user/${user.id}`);
    closeModal();
  };

  return (
    <div className="dimd-layer">
      <div className="inner big-type">
        <section className="cnts-introduce">
          <div className="profile-w">
            <span
              className="photo"
              style={{ backgroundImage: `url(${profile_image})` }}
            />
            <em>{profile.display_name}</em>
          </div>
          <div className="keyword-w">
            {keywords.map((keyword, index) => (
              <a key={index}>{convertHashTag(keyword)}</a>
            ))}
          </div>
          <div className="cnts">{profile.bio}</div>
          <div className="sns-w">
            <ul>
              {!hasSNS ? null : (
                <>
                  {snsList.map((sns, index) => {
                    if (sns.name !== '')
                      return (
                        <li key={index}>
                          <a
                            href={sns.href}
                            className={sns.c_name}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {sns.name}
                          </a>
                        </li>
                      );
                  })}
                </>
              )}
            </ul>
          </div>
          <div className="ly-btn">
            <a onClick={clickOtherFeeds} style={{ cursor: 'pointer' }}>
              작성글 보기
            </a>
          </div>
          <button type="button" className="btn-close" onClick={closeModal}>
            <span>팝업 닫기</span>
          </button>
        </section>
      </div>
    </div>
  );
};

export default ModalMyProfile;
